import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=2f3e55b8&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=ts&"
export * from "./MyOrders.vue?vue&type=script&lang=ts&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=2f3e55b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3e55b8",
  null
  
)

export default component.exports